import { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const t = localStorage.getItem("gre_admin_token");
    if (!t) { setUser(null); return; }
    adminApi.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("gre_admin_token"); setUser(null); });
  }, []);

  const login = async (email, password) => {
    const r = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem("gre_admin_token", r.data.token);
    setUser(r.data.user);
  };

  const logout = () => {
    localStorage.removeItem("gre_admin_token");
    setUser(null);
  };

  const refresh = async () => {
    const r = await adminApi.get("/auth/me");
    setUser(r.data);
  };

  return <AuthContext.Provider value={{ user, login, logout, refresh }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
